import { createSlice } from "@reduxjs/toolkit"

interface GlobalState {
  activeTab: any
  selctedPlatform: any
  selectedPlatformSlug: any
  selectedCategory: any
  searchQuery: any
  selctedArticlesForCurrentCategory: any
  singleArticlePost: any
  trendingArticles: any
  aiChat: any
  isChatAiOpen:false,
  currentSupportMessage: string
}

const initialState: GlobalState = {
  activeTab: null,
  selctedPlatform: null,
  selectedPlatformSlug: null,
  selectedCategory: null,
   isChatAiOpen:false,
  searchQuery: null,
  selctedArticlesForCurrentCategory: [],
  singleArticlePost: null,
  trendingArticles: [],
  aiChat: [],
  currentSupportMessage: "",
}

export const global = createSlice({
  name: "global",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setAiChat: (state, action) => {
      state.aiChat = action.payload
    },
    setSelectedPlatform: (state, action) => {
      state.selctedPlatform = action.payload
    },
    setSelectedPlatformSlug: (state, action) => {
      state.selectedPlatformSlug = action.payload
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload
    },
    setSelctedArticlesForCurrentCategory: (state, action) => {
      state.selctedArticlesForCurrentCategory = action.payload
    },
    setSingleArticlePost: (state, action) => {
      state.singleArticlePost = action.payload
    },
    setTrendingArticles: (state, action) => {
      state.trendingArticles = action.payload
    },
    setCurrentSupportMessage: (state, action) => {
      state.currentSupportMessage = action.payload
    },
    setIsChatAiOpen: (state, action) => {
          state.isChatAiOpen = action.payload
        },
  },
})

export const {
  setActiveTab,
  setSelectedPlatformSlug,
  setSelectedCategory,
  setSearchQuery,
  setSelctedArticlesForCurrentCategory,
  setSingleArticlePost,
  setTrendingArticles,
  setIsChatAiOpen,
  setAiChat,
  setCurrentSupportMessage,
} = global.actions
export const selectGlobalState = (state: any) => state.global
export default global.reducer
